<template>
    <el-button class="x-button x-button-cancel" @click="$emit('click')">{{ text }}</el-button>
</template>

<script>

export default {
    name: 'XButtonCancel',
    props: {
        text: {
            type: String,
            default: 'Cancelar'
        },
    },
    data() {
        return {}
    },
}
</script>
